// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__129ay","left":"InfoRow_left__1_kwK"};